import { Rocket } from 'lucide-react'
import { useState } from 'react'
import { cn } from '../../utils/cn'

export default function LearningObjectivesCard({
  objectives = [],
  title = 'Objetivos de Aprendizagem',
  subtitle = 'Certifique-se de que você consegue explicar com clareza os fundamentos apresentados até aqui.',
  className,
}) {
  const [open, setOpen] = useState(false)

  return (
    // widget fixo no canto inferior-direito: acompanha o scroll e flutua
    // sobre o conteúdo (não empurra o layout). Abre apenas no hover/foco da
    // pílula (o card fechado tem pointer-events-none e não dispara nada);
    // fecha ao sair da área toda, para o mouse poder ir da pílula ao card.
    <div
      onMouseLeave={() => setOpen(false)}
      onBlur={() => setOpen(false)}
      className={cn(
        // bottom-28 = acima do botão flutuante do RD Station/WhatsApp (90px) no canto
        'fixed bottom-28 right-8 z-50 flex flex-col items-end gap-3',
        className,
      )}
    >
      <div
        className={cn(
          'w-[421px] max-w-[90vw] origin-bottom-right rounded-[10px] border border-[#E0E0E0] bg-[#FDFDFD] p-6 shadow-2xl transition-all duration-200 ease-out',
          open
            ? 'pointer-events-auto translate-y-0 scale-100 opacity-100'
            : 'pointer-events-none translate-y-2 scale-95 opacity-0',
        )}
        aria-hidden={!open}
      >
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1.5">
            <h3 className="font-inter-extrabold text-lg text-[#454545]">
              {title}
            </h3>
            <p className="font-inter-regular text-sm text-[#6A7282]">
              {subtitle}
            </p>
          </div>

          <ol className="flex flex-col gap-4">
            {objectives.map((objective, index) => (
              <li key={objective} className="flex items-center gap-4">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#454545] font-titillium-web-bold text-sm text-white">
                  {index + 1}
                </span>
                <span className="font-inter-regular text-sm text-[#364153]">
                  {objective}
                </span>
              </li>
            ))}
          </ol>
        </div>
      </div>

      <button
        type="button"
        aria-label="Objetivos de aprendizagem para esta seção"
        aria-expanded={open}
        onMouseEnter={() => setOpen(true)}
        onFocus={() => setOpen(true)}
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-3 rounded-full border border-[#E0E0E0] bg-[#F9F9F9] px-6 py-2 shadow-lg"
      >
        <Rocket className="h-8 w-8 shrink-0 text-[#939393]" />
        <span className="font-inter-regular text-sm italic text-[#666666]">
          Objetivos de aprendizagem para esta seção.
        </span>
      </button>
    </div>
  )
}
